import { featureOn } from '@/helpers/entitlements'
import privilegeService from '@/services/privilege.service'

export const MEMBERSHIP_FEATURE = 'membership_program'

export const TIER_OVERVIEW_TAB = { id: 'overview', name: 'Overview' }

export const TIER_AUDIENCE_TABS = [
  'filters',
  'drops',
  'orders',
  'uber-deliveries',
  'carts',
  'products',
  'customers',
  'automations',
  'reports'
]

export const TIER_VIEW_TABS = [TIER_OVERVIEW_TAB.id, ...TIER_AUDIENCE_TABS]

const TIERS_PATH = '/store/membership-tiers'

export const tierViewPath = (tierId, tab) => {
  const base = `${TIERS_PATH}/${tierId}`
  return !tab || tab === TIER_OVERVIEW_TAB.id ? base : `${base}/${tab}`
}

// BOT-1793: membership tiers are a plan feature. The tier routes bounce to Sell
// on a plan without it, so every link to them asks here first.
export const hasMembershipProgram = user => featureOn(user, MEMBERSHIP_FEATURE)

export const canOpenTierView = user => privilegeService.canAccessRoute(TIERS_PATH) && hasMembershipProgram(user)
